var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switchWrap"},[_c('div',{staticClass:"switch",on:{"click":_vm.toggle}},[_c('span',{staticClass:"circle",class:_vm.isChecked ? "circleChecked a-12-bg" : "circleCheckOut a-1-bg",style:(_vm.circleStyle)}),_c('p',{class:_vm.isChecked ? "switchBottomChecked a-14-bg" : "switchBottom a-2-bg",style:(_vm.boxStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }